import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    colorTokenArgs,
    designContext,
    disabled,
    turnOffTouchability,
    interactiveState,
    isSmall
  } = _ref;
  var clickableRadius = isSmall ? 0 : 6;
  var borderRadius = designContext.get('touchable-icon/corner-radius').value();
  return {
    wrapperStyle: {
      alignItems: 'flex-start'
    },
    containerStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: disabled || turnOffTouchability ? 'default' : 'pointer',
      display: 'flex',
      padding: 0,
      position: 'relative',
      outline: 0,
      overflow: 'visible',
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    focusedBorderStyle: {
      position: 'absolute',
      borderColor: colorToken ? designContext.get(colorToken, colorTokenArgs).toString() : designContext.get('touchable-icon/color').toString(),
      borderRadius,
      borderStyle: 'solid',
      borderWidth: 2,
      bottom: 0,
      left: 0,
      right: 0,
      top: 0
    },
    overlayStyle: {
      margin: -clickableRadius
    },
    iconWrapperStyle: {
      margin: clickableRadius
    },
    iconColorToken: colorToken ? colorToken : 'touchable-icon/color',
    iconColorTokenArgs: _objectSpread({
      interactiveState
    }, colorToken ? colorTokenArgs : {})
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map